
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export interface EventTypeStat {
  name: string;
  count: number;
}

interface EventOverviewChartProps {
  eventTypeStats: EventTypeStat[];
}

const EventOverviewChart = ({ eventTypeStats }: EventOverviewChartProps) => {
  const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Event Overview</CardTitle>
        <CardDescription>Distribution of tracked events by type</CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center">
        <div style={{ width: 300, height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={eventTypeStats}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="count"
                nameKey="name"
                label={({name}) => name}
              >
                {eventTypeStats.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default EventOverviewChart;
